<template>
  <div class="home">
    <div class="px-3">
      <MealSetRegister/>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import MealSetRegister from '@/components/MealSetRegister.vue';

export default {
  name: 'HomeView',
  components: {
    MealSetRegister,
  },
  head() {
    return {
      title: 'Đăng ký cơm',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Phần mềm đăng ký cơm dành cho nhân viên ASGL',
        },
      ],
    };
  },
};
</script>

<style scoped>
.home {
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: row;
  height: 100vh;
}

.my-auto {
  margin-bottom: auto;
  margin-top: auto;
}

.px-3 {
  padding-left: 40px;
  padding-right: 40px;
}
</style>
